
export default function About() {
  const features = [
    { icon: 'ri-code-s-line', label: 'Expert Code' },
    { icon: 'ri-shield-check-line', label: 'Security First' },
    { icon: 'ri-palette-line', label: 'Modern Design' },
    { icon: 'ri-speed-line', label: 'Performance' },
    { icon: 'ri-customer-service-2-line', label: 'Support' }
  ];

  return (
    <section id="about" className="py-32 bg-gray-900">
      <div className="max-w-6xl mx-auto px-8 text-center">
        <p className="text-xs uppercase tracking-widest text-gray-500 mb-6">
          About JAMNIK d.o.o.
        </p>
        <h2 className="text-6xl font-bold text-white leading-tight mb-16" style={{ fontFamily: 'Georgia, serif', letterSpacing: '-0.02em' }}>
          A Team of Experts<br />
          Developing Modern Applications<br />
          For the iOS Platform
        </h2>

        <div className="flex flex-wrap justify-center gap-8 mt-20">
          {features.map((feature, index) => (
            <div
              key={index}
              className="flex items-center gap-4 bg-gray-800 hover:bg-gray-750 transition-all duration-300 rounded-2xl px-10 py-8 cursor-pointer"
            >
              <i className={`${feature.icon} text-2xl text-white w-6 h-6 flex items-center justify-center`}></i>
              <span className="text-white text-sm font-medium whitespace-nowrap">{feature.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}